import { makeStyles } from '@rbx/ui';
import { engineRevampBaseTextStyle } from '@modules/ui/shared/utils/styles';

const useReferenceMemberParametersTableStyles = makeStyles()((theme) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    title: {
      marginTop: 0,
      marginBottom: '20px',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '100%',
    },
    table: {
      border: `1px solid ${theme.palette.components.divider}`,
      borderRadius: '4px',
      borderCollapse: 'separate',
      overflow: 'hidden',
    },
    tableRow: {
      '& td': {
        padding: '12px',
        borderBottom: `1px solid ${theme.palette.components.divider}`,
      },
      '&:last-child td': {
        borderBottom: 'none',
      },
    },
    parameterName: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      flexWrap: 'wrap',
    },
    parameterText: {
      ...engineRevampBaseTextStyle,
      fontFamily: '"Builder Mono", monospace',
      fontWeight: 400,
    },
    defaultValue: {
      marginTop: '4px',
      color: theme.palette.content.muted,
    },
  };
});

export default useReferenceMemberParametersTableStyles;
